import { IBackendOfferResponse } from '../../types/common/offer';
import { IOfferCardProps } from '../../components/OfferCard';
import { mapThemBtn } from '../../constants/mapButtonThemes';
import { enrichOfferLinkWithParams } from './enrichOfferLinkWithParams';

export function transformOffers(
  rawOffer: IBackendOfferResponse,
  index: number,
  queryParams?: Record<string, string>,
): IOfferCardProps {
  const btnTheme = mapThemBtn[rawOffer.button.theme];
  const enrichedOfferLink = enrichOfferLinkWithParams(rawOffer.button.path, queryParams || {});

  return {
    title: {
      objectType: rawOffer.objectType,
      realEstateType: rawOffer.realEstateType,
      iconPath: rawOffer.bank.iconPath,
      name: rawOffer.bank.name,
      modalContent: rawOffer?.modal?.rows,
    },
    button: {
      text: rawOffer.button.text,
      path: enrichedOfferLink,
      theme: btnTheme,
      authorizationRequired: rawOffer.button.authorizationRequired,
      bankName: rawOffer.bank.name,
      analyticEventKey: rawOffer.button.analyticEventKey,
    },
    description: {
      text: rawOffer.description?.text,
      title: rawOffer.description?.title,
      links: rawOffer.description?.links,
    },
    conditions: {
      rate: rawOffer?.rate,
      income: rawOffer?.income,
      limit: rawOffer?.limit,
      monthlyPayment: rawOffer?.monthlyPayment,
      psk: rawOffer?.psk,
    },
    requirements: rawOffer.description?.requirements,
    promotion: {
      aboutAdvertiser: rawOffer.promotion?.aboutAdvertiser,
      bannerImgPaths: {
        imgPathDesktop: rawOffer.promotion?.picture.desktopUrl,
        imgPathMobile: rawOffer.promotion?.picture.mobileUrl,
        imgPathTablet: rawOffer.promotion?.picture.tabletUrl,
      },
    },
    labels: rawOffer.labels,
    placeOnList: index,
  };
}
